import { get } from 'lodash';
var ReduxStoreBridge = /** @class */ (function () {
    function ReduxStoreBridge() {
    }
    ReduxStoreBridge.configure = function (store) {
        ReduxStoreBridge.store = store;
        ReduxStoreBridge.previousState = store.getState();
        store.subscribe(function () { return ReduxStoreBridge.notifyListeners(); });
    };
    ReduxStoreBridge.notifyListeners = function () {
        var previousState = this.previousState;
        var newState = ReduxStoreBridge.store.getState();
        ReduxStoreBridge.listeners.forEach(function (listener) {
            var prevValue = get(previousState, listener.key);
            var newValue = get(newState, listener.key);
            if (prevValue !== newValue) {
                listener.callback(newValue);
            }
        });
        ReduxStoreBridge.previousState = newState;
    };
    ReduxStoreBridge.subscribe = function (key, callback) {
        ReduxStoreBridge.listeners.push({
            key: key,
            callback: callback,
        });
        return function () { return ReduxStoreBridge.unsubscribe(callback); };
    };
    ReduxStoreBridge.unsubscribe = function (callback) {
        ReduxStoreBridge.listeners = ReduxStoreBridge.listeners.filter(function (listener) { return listener.callback !== callback; });
    };
    ReduxStoreBridge.getOnce = function (selector) {
        if (typeof selector === 'string') {
            return get(ReduxStoreBridge.previousState, selector);
        }
        return selector(ReduxStoreBridge.previousState);
    };
    ReduxStoreBridge.dispatch = function (action) {
        return ReduxStoreBridge.store.dispatch(action);
    };
    ReduxStoreBridge.listeners = [];
    return ReduxStoreBridge;
}());
export { ReduxStoreBridge };
